import React from "react";
import { CowsLocationsPage } from "./CowsLocationsPage";
import { useCowsLocations } from "./useCowsLocations";

function CowsLocations() {
  return <CowsLocationsPage {...useCowsLocations()} />;
}

export default CowsLocations;
